import React, { useEffect, useState } from "react";
import { AUTH_MODE } from "../config";
import { APIRequest } from "../helpers/api/auth";
import Loader from "../components/Loader";

const CALLBACK_PARAMS = ["user_id", "token", "jwt"];

// removes the params the backend adds after login, keeps the jwt in header mode
export const consumeLoginCallback = (): boolean => {
  const url = new URL(window.location.href);
  const jwt = url.searchParams.get("jwt");

  // needs user_id too, so the app's own "token" or "jwt" params stay untouched
  const isCallback =
    url.searchParams.has("user_id") &&
    (url.searchParams.has("token") || url.searchParams.has("jwt"));
  if (!isCallback) return false;

  if (AUTH_MODE === "header" && jwt) {
    localStorage.setItem("Authorization", jwt);
  }

  CALLBACK_PARAMS.forEach((param) => url.searchParams.delete(param));
  window.history.replaceState(
    window.history.state,
    "",
    url.pathname + url.search + url.hash
  );
  return true;
};

const refreshUserData = async () => {
  const response = await APIRequest("user/me", "GET");
  if (response?.data) {
    localStorage.setItem("userData", JSON.stringify(response.data));
  }
};

// handles the login callback and checks the session before any page renders
const AuthGate = ({ children }: { children: React.ReactNode }) => {
  // the logout page works without a session
  const skip = window.location.pathname.startsWith("/auth/");
  const [ready, setReady] = useState(skip);

  useEffect(() => {
    if (skip) return;

    let cancelled = false;
    consumeLoginCallback();

    refreshUserData()
      .catch((error) => console.error("Could not load user data:", error))
      .finally(() => {
        if (!cancelled) setReady(true);
      });

    return () => {
      cancelled = true;
    };
  }, [skip]);

  return ready ? <>{children}</> : <Loader />;
};

export default AuthGate;
